
import { bindable } from 'aurelia-framework';
import { Item } from "../../../data/entities/entities";
import { ListBoxItem } from "../../../core/list-box-item";
import { NodeAspect } from "../../../core/node-aspect";
export class ListBox {

    @bindable items : Array<Item> = [];
    @bindable save: Function;
    @bindable changed;

    itemsChanged(newValue, oldValue) {
        if (newValue) {
            newValue.forEach(
            (a) => this.wrapItem(a)
            );
        }
    }

    @bindable selectedItem;

    onMouseOver(item) {
        item.nodeAspect.isHovering = true;
    }

    onMouseOut(item) {
        item.nodeAspect.isHovering = false;
    }

    wrapItem(item: ListBoxItem) {
        this.addNodeAspect(item);
    }

    selectedItemChanged(newValue: ListBoxItem, oldValue: ListBoxItem) {
        if (oldValue && oldValue.nodeAspect) oldValue.nodeAspect.isSelected = false;
        if (newValue && newValue.nodeAspect) newValue.nodeAspect.isSelected = true;
    }

    callOnSelectedItemChanged(item) {
        this.changed({ selectedItem: item });
    }


    handleKeyPress(event, item) {
        if (event.keyCode === 13) {
            this.saveEdit(item);
        }
    }

    nodeSelected(item) {
        this.selectedItem = item;
        this.callOnSelectedItemChanged(item);
    }

    saveEdit(item: ListBoxItem) {
        item.nodeAspect.isEditing = false;
        this.callSave(item);
    }

    //This is calling the bound save which requires a special syntax.
    callSave(item: ListBoxItem) {
        this.save({ itemToSave: item });
    }

    addNodeAspect(item: ListBoxItem) {
        item.nodeAspect = new NodeAspect();
    }

    inputOnBlur(item) {
        item.nodeAspect.isEditing = false;
    }

    nodeDoubleClick(item) {
        item.nodeAspect.isEditing = true;
    }

    


}
